import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey } from '../../query/types';
import { studentFeesConsumerFeesKeys } from './fees/keys';
import { studentFeesConsumerStudentsKeys } from './students/keys';

const studentFeesConsumerKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'fees'] as const;
  return createQueryKey({
    all: [...key] as const,
    fees: studentFeesConsumerFeesKeys(key),
    students: studentFeesConsumerStudentsKeys(key),
  });
};

export { studentFeesConsumerKeys };
